import { select } from '@js/util/select'

if (!flatpickr) {
  window.flatpickr = {
    l10ns: {}
  }
}

flatpickr.l10ns.de = {
  weekdays: {
    shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    longhand: [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ],
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez",
    ],
    longhand: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
  },
  firstDayOfWeek: 1,
  weekAbbreviation: "KW",
  rangeSeparator: " bis ",
  scrollTitle: "Zum Ändern scrollen",
  toggleTitle: "Zum Umschalten klicken",
  time_24hr: true,
};

select('.wpforms-field', el => {
  let input = el.querySelector('textarea, input')
  if (!input) return

  let toggle = () => {
    el.classList.toggle('wpforms-field-filled', input.value.length > 0)
  }

  toggle()
  input.addEventListener('blur', toggle)

  return () => {
    input?.removeEventListener('blur', toggle)
  }
})
